export default __webpack_public_path__ + "static/media/Figure-3.44fdaaef.jpg";